// Illustrations 
import cancion from './assets/artworks/cancion.webp';
import fireball from './assets/artworks/fireball.webp';
import demonio from './assets/artworks/demonio.webp';
import AS from './assets/artworks/ancient_set.webp';
import CoM from './assets/artworks/change_of_mind.webp';
import lovelace from './assets/artworks/lovelace.webp';
import omara from './assets/artworks/omara.webp';

import comic2 from './assets/artworks/comic2.webp';

import card3 from './assets/artworks/card3.JPG';
import card4 from './assets/artworks/card4.JPG';
import donc from './assets/artworks/doncella.jpg';
import moon from './assets/artworks/moon.webp';
import sapito from './assets/artworks/sapitomago.webp';

// Character art
import om1 from './assets/charart/om1.webp';
import solfi from './assets/charart/solfi.webp';
import scs from './assets/charart/scs.webp';
import gbp from './assets/charart/gbp.webp';
import noro from './assets/charart/noro.webp';
import rocco from './assets/charart/rocco.webp';
import ily from './assets/charart/ily.webp';
import lucca from './assets/charart/lucca.webp';
import volley from './assets/charart/volley.webp';
import giri from './assets/charart/giri.webp';
import aure from './assets/charart/aure.webp';
import jo from './assets/charart/jo.webp';
import max from './assets/charart/maxwell.webp';
import kosj from './assets/charart/kosj.webp';
import auri from './assets/charart/auri.webp';

import coms1 from  './assets/coms/coms1.webp';
import coms2 from  './assets/coms/coms2.webp';
import coms3 from  './assets/coms/coms3.webp';
import coms4 from  './assets/coms/coms4.webp';
import coms5 from  './assets/coms/coms5.webp';
import coms6 from  './assets/coms/coms6.webp';



export const artworkImgs = [{
    id: 1,
    imgSrc: AS,
    desc: "Ancient Set - Personal work", 
    page: "artworks"
  },
{
    id: 2,
    imgSrc: CoM,
    desc: "Comic page - Inspired in podcast Wolf 359, 'Change of Mind'",
    page: "artworks"
  },
    {
    id: 5,
    imgSrc: card3,
    desc: "Stars, Sisters of Wonder - Personal work",
    page: "artworks"
  },
    {
    id: 6,
    imgSrc: card4,
    desc: "The World - Personal work",
    page: "artworks"
  },
  {
    id: 7,
    imgSrc: donc,
    desc: "Cover illustration for 'La doncella aguja' by Marina Closs. Published by Laurel Libros.",
    page: "artworks"
  },
  {
    id: 8,
    imgSrc: cancion,
    desc: "Cover illustration for 'Canción, llévame lejos' by Mauro Libertella. Published by Laurel Libros.",
    page: "artworks"
  },
  {
    id: 9,
    imgSrc: demonio,
    desc: "Demonio amigo - Personal work",
    page: "artworks"
  },
  {
    id: 10,
    imgSrc: fireball,
    desc: "Fireball - Personal work",
    page: "artworks"
  },
  {
    id: 11,
    imgSrc: lovelace,
    desc: "Lovelace - Personal work, inspired by podcast Wolf 359",
    page: "artworks"
  },
  // {
  //   id: 12,
  //   imgSrc: comic1,
  //   desc: "",
  //   page: "artworks"
  // },
  {
    id: 13,
    imgSrc: comic2,
    desc: "Short comic page - Personal work",
    page: "artworks"
  }, 
  {
    id: 14,
    imgSrc: omara,
    desc: "Omara - Personal work",
    page: "artworks"
  }, 
  {
    id: 29,
    imgSrc: moon,
    desc: "Moon - Personal work",
    page: "artworks"
  }, 
  {
    id: 30,
    imgSrc: sapito,
    desc: "Sapito mago - Personal work",
    page: "artworks"
  }, 
];

export const charArtImgs = [
  {
    imgSrc: scs,
    desc: "",
  },
  {
    imgSrc: om1,
    desc: "",
  },
  {
    imgSrc: solfi,
    desc: "",
  },
  {
    imgSrc: gbp,
    desc: "",
  },
  {
    imgSrc: noro,
    desc: "",
  },
  {
    imgSrc: rocco,
    desc: "",
  },
  {
    imgSrc: ily,
    desc: "",
  },
  {
    imgSrc: lucca,
    desc: "",
  },
  {
    imgSrc: volley,
    desc: "",
  },
  {
    imgSrc: giri,
    desc: "",
  },
  {
    imgSrc: aure,
    desc: "",
  },
  {
    imgSrc: jo,
    desc: "",
  },
  {
    imgSrc: max,
    desc: "",
  },
  {
    imgSrc: kosj,
    desc: "",
  },
  {
    imgSrc: auri,
    desc: "",
  },
]

export const comsImgs = [
  {
    imgSrc: coms1,
    desc: "",
  },
  {
    imgSrc: coms2,
    desc: "",
  },
  {
    imgSrc: coms3,
    desc: "",
  },
  {
    imgSrc: coms4,
    desc: "",
  },
  {
    imgSrc: coms5,
    desc: "",
  },
  {
    imgSrc: coms6,
    desc: "",
  },
]